<template>
    <div class="my-3">
        <div class="overflow-hidden" style="height: 800px;">

            <b-navbar variant="light" class="px-1">
                <b-navbar-nav>
                    <b-nav-item href="#" @click="prevMonth">
                        <font-awesome-icon class="fa-fw" icon="chevron-left" />
                    </b-nav-item>
                </b-navbar-nav>

                <b-nav-form>
                    <b-input-group class="" size="sm">
                        <b-form-select ref="month" v-model="filters.month" :options="optionsMonth()" @change="fetchMonth"></b-form-select>
                    </b-input-group>
                </b-nav-form>

                <b-navbar-nav>
                    <b-nav-item href="#" @click="nextMonth">
                        <font-awesome-icon class="fa-fw" icon="chevron-right" />
                    </b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item href="#" @click="undo" :disabled="getDoneActionsCount() === 0">
                        <font-awesome-icon class="fa-fw" icon="undo" />
<!--
                        {{ getDoneActionsCount() }}
-->
                    </b-nav-item>
                    <b-nav-item href="#" @click="redo" :disabled="getUndoneActionsCount() === 0">
                        <font-awesome-icon class="fa-fw" icon="redo" />
<!--
                        {{ getUndoneActionsCount() }}
-->
                    </b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-nav-form class="ml-auto">
                    <b-button variant="primary" size="sm" @click="saveMonth">
                        <font-awesome-icon class="fa-fw" icon="save" />
                        保存
                    </b-button>
                </b-nav-form>
            </b-navbar>

            <hot-table ref="hotTable" :settings="hotSettings"></hot-table>

        </div>

            <hr/>

            <h5>Preview</h5>
            <!--
            <CalendarInfoDetail
                :model="model"
                :date="date"
                :month="month"
                :user_log="user_log"
                @change="toggleUserLog"
                />
            -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import User from '@/components/User.vue'
import UserBadges from '@/components/UserBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import FormDate from '@/components/FormDate.vue'
import ItemInfo from '@/components/ItemInfo.vue'

import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
//import { createSpreadsheetData } from './helpers'

registerAllModules();

const versesValidator = (value, callback) => {
    if (value === null || value === '') {
        callback(true)
        return
    }
    let verses = value.split(',')
    for (let i = 0; i < verses.length; i++) {
        let verse = Number(verses[i])
        if (!Number.isSafeInteger(verse)) {
            callback(false)
            return
        }
        if (verse <= 0) {
            callback(false)
            return
        }
        if (i > 0) {
            if (verse <= Number(verses[i - 1])) {
                callback(false)
                return
            }
        }
    }
    callback(true)
}

const isValidHttpUrl = (string) => {
    let url

    try {
        url = new URL(string)
    } catch (_) {
        return false
    }

    return url.protocol === 'http:' || url.protocol === 'https:'
}

const urlsValidator = (value, callback) => {
    if (value === null || value === '') {
        callback(true)
        return
    }
    let urls = value.split(',')
    for (let i = 0; i < urls.length; i++) {
        let url = urls[i]
        if (!isValidHttpUrl(url)) {
            callback(false)
            return
        }
    }
    callback(true)
}

const sourceBooks = () => {
    return [ 'GEN', 'EXO', 'LEV', 'NUM', 'DEU', 'JOS', 'JDG', 'RUT', '1SA', '2SA', '1KI', '2KI', '1CH', '2CH', 'EZR', 'NEH', 'EST', 'JOB', 'PSA', 'PRO', 'ECC', 'SNG', 'ISA', 'JER', 'LAM', 'EZK', 'DAN', 'HOS', 'JOL', 'AMO', 'OBA', 'JON', 'MIC', 'NAM', 'HAB', 'ZEP', 'HAG', 'ZEC', 'MAL', 'MAT', 'MRK', 'LUK', 'JHN', 'ACT', 'ROM', '1CO', '2CO', 'GAL', 'EPH', 'PHP', 'COL', '1TH', '2TH', '1TI', '2TI', 'TIT', 'PHM', 'HEB', 'JAS', '1PE', '2PE', '1JN', '2JN', '3JN', 'JUD', 'REV', ]
}


export default {
    components: {
        GridPage,
        User,
        UserBadges,
        ItemThumb,
        FormDate,
        ItemInfo,
        HotTable,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ]),
    },
    data() {
        return {
            filters: {
                month: null,
            },
            hotRef: null,
            hotSettings: {
                afterChange: (changes, source) => {
                    if (this.afterChange) {
                        this.afterChange(changes, source)
                    }
                },
                rowHeaders: true,
                colHeaders: true,
                licenseKey: 'non-commercial-and-evaluation',
                stretchH: 'all',
//                contextMenu: true,
                width: '100%',
                allowInsertColumn: false,
                allowInsertRow: false,
                allowRemoveColumn: false,
                allowRemoveRow: false,

                autoRowSize : false,
                viewportColumnRenderingOffset: 70,

                afterGetRowHeader: function(col, TH) {
                    TH.className = 'text-left'
                },
                colHeaders: [ '新約', '章節', 'URL', '旧約（前）', '章節', 'URL', '旧約（後）', '章節', 'URL', '詩篇', '章節', 'URL', ],
                rowHeaders: [],
                columns: [
                    {
                        type: 'dropdown',
                        source: sourceBooks(),
                    },
                    {
                        type: 'text',
                        validator: versesValidator,
                    },
                    {
                        type: 'text',
                        validator: urlsValidator,
                    },
                    {
                        type: 'dropdown',
                        source: sourceBooks(),
                    },
                    {
                        type: 'text',
                        validator: versesValidator,
                    },
                    {
                        type: 'text',
                        validator: urlsValidator,
                    },
                    {
                        type: 'dropdown',
                        source: sourceBooks(),
                    },
                    {
                        type: 'text',
                        validator: versesValidator,
                    },
                    {
                        type: 'text',
                        validator: urlsValidator,
                    },
                    {
                        type: 'dropdown',
                        source: sourceBooks(),
                    },
                    {
                        type: 'text',
                        validator: versesValidator,
                    },
                    {
                        type: 'text',
                        validator: urlsValidator,
                    },
                ],
            },
            data: [
                [ '', '', '', '', '', '', '', '', '', '', '', '', ],
                [],
                [ 'MAT', '1', 'https://youtu.be/sXT83Nybjo4', 'GEN', '1,2', '', 'EZR', '1', '', 'PSA', '1,2', '', ],
                [ 'MAT', '2', '', 'GEN', '3,4', '', 'EZR', '2', '', 'PSA', '3,4', '', ],
                [ 'MAT', '3', '', 'GEN', '5,6', '', 'EZR', '3,4', '', 'PSA', '5', '', ],
                [ 'MAT', '4', '', 'GEN', '7,8', '', 'EZR', '5', '', 'PSA', '6,7', '', ],
                [ 'MAT', '5', '', 'GEN', '9', '', 'EZR', '6', '', 'PSA', '8', '', ],
                [],
                [],
                [ 'MAT', '6', '', 'GEN', '10,11', '', 'EZR', '7', '', '', '', ],
                [ 'MAT', '7', '', 'GEN', '12,13,14', '', 'EZR', '8', '', '', '', ],
                [ 'MAT', '8', '', 'GEN', '15,16', '', 'EZR', '9', 'PSA', '9', '', ],
                [ 'MAT', '9', '', 'GEN', '17,18', '', 'EZR', '10', '', '', '', ],
                [ 'MAT', '10', '', 'GEN', '19', '', 'NEH', '1', 'PSA', '10', '', ],
                [],
                [],
                [ 'MAT', '11', '', 'GEN', '20,21', '', 'NEH', '2', 'PSA', '11,12', '', ],
            ],
        }
    },
    async mounted() {
        this.hotRef = this.$refs.hotTable.hotInstance
        this.filters.month = this.$moment().format('YYYYMM')
        await this.fetchMonth()
    },
    methods: {
        async prevMonth() {
            let index = this.$refs.month.options.findIndex(v => v.value === this.filters.month)
            index--
            if (index < 0) {
                return
            }
            this.filters.month = this.$refs.month.options[index].value
            await this.fetchMonth()
        },
        async nextMonth() {
            let index = this.$refs.month.options.findIndex(v => v.value === this.filters.month)
            index++
            if (this.$refs.month.options.length <= index) {
                return
            }
            this.filters.month = this.$refs.month.options[index].value
            await this.fetchMonth()
        },
        async fetchMonth() {
            await this.$store
                .dispatch('calendar/show', { uuid: this.filters.month, })
                .then((response) => {
                    let newSettings = JSON.parse(JSON.stringify(this.hotSettings))
                    newSettings.rowHeaders.splice(0)
                    for (let i = 0; i < response.data.data.data.length; i++) {
                        const month = this.$moment(response.config.url.split('/').at(-1) + (i + 1 + '').padStart(2, '0'))
                        newSettings.rowHeaders.push(month.format('(ddd)DD'))
                    }
                    this.hotRef.updateSettings(newSettings)

console.log(response.data.data.data)
                    this.hotRef.loadData(response.data.data.data)

                    this.hotRef.deselectCell()

                    this.$forceUpdate()
//                    this.hotRef.clear()
                    this.hotRef.clearUndo()
                })
                .catch((error) => {
                })
        },
        async undo() {
            this.hotRef.undo()
        },
        async redo() {
            this.hotRef.redo()
        },
        getDoneActionsCount () {
            if (!this.hotRef
                || !this.hotRef.undoRedo
            ) {
                return 0
            }
            return this.hotRef.undoRedo.doneActions.length
        },
        getUndoneActionsCount () {
            if (!this.hotRef
                || !this.hotRef.undoRedo
            ) {
                return 0
            }
            return this.hotRef.undoRedo.undoneActions.length
        },
        afterChange (changes, source) {
            this.$forceUpdate()
        },
        async saveMonth () {
//            console.log(this.hotRef.getData())
//            return
            await this.$store
                .dispatch('calendar/save', { uuid: this.filters.month, data: this.hotRef.getData(), })
                .then((response) => {
                })
                .catch((error) => {
                })
        },
        optionsMonth() {
            let years = [...Array(10).keys()].map((v) => { return v + 2022 + '' })
            let monthes = [...Array(12).keys()].map((v) => { return (v + 1 + '').padStart(2, '0') })
            let options = []
            for (let i = 0; i < years.length; i++) {
                for (let j = 0; j < monthes.length; j++) {
                    options.push({
                        value: years[i] + monthes[j],
                        text: years[i] + '/' + monthes[j],
                    })
                }
            }
            return options
        },
    },
}
</script>

